import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useTranslation } from "react-i18next";

const domainRegex = /^@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;


export const useResolver = () => {
  const { t } = useTranslation();
  return yupResolver(
    yup.object().shape({
      name: yup.string().required(),
      domain: yup.string().optional().test(
        'is-valid-domain',
        t('organizations.domainError'),
        value => !value || domainRegex.test(value)
      ),
    })
  );
}
